import { render, staticRenderFns } from "./InformationBasicCard.vue?vue&type=template&id=6fc44327&scoped=true&"
import script from "./InformationBasicCard.vue?vue&type=script&lang=js&"
export * from "./InformationBasicCard.vue?vue&type=script&lang=js&"
import style0 from "./InformationBasicCard.vue?vue&type=style&index=0&id=6fc44327&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc44327",
  null
  
)

export default component.exports